import { Button } from "@mui/material";
import React, { Fragment, useRef } from "react";
import CONSTANTS from "../../CONSTANTS";
import gema_logo from "../../assets/img/vacspl/gema_logo.png";
import emailConfig from './emailConfigs'
import emailModals from "./emailModals";
import EmailFooter from "./EmailFooter";
import EmailSignature from "./EmailSignature";

// import vacspl_logo from "../../assets/img/vacspl/vacspl_logo.png";


const TestClipboard = (props) => {
    const contentRef = useRef();
    const { form, selectedSpare, user } = props.data
    // const client_name = form && form.client && form.client.client_name && `Mr. ${form.client.client_name}`

    const { LANGUAGES } = emailConfig
    const {
        // DAMAGED_HEAD,
        // DAMAGED_SPARE_LIST_CONTENT,
        // DAMAGED_SPARE_GEN_CONTENT,

        // INTACT_HEAD,
        // INTACT_SPARE_LIST_CONTENT,
        // INTACT_SPARE_GEN_CONTENT,

        // NEARLY_DAMAGED_COMPONENT,
        // NON_DAMAGED_BUT_OLD_COMPONENT,
        // PLANT_CONDITION,
        // DUPLICATE_SPARES,
        // PAST_SPARE_PURCHASED,
        // IMPACT_ON_COST,
        // COMMUNICATION_STARTER,
        OVERALL_PLANT_CONDITION,
        // PAST_MATERIAL_PURCHASED,
        // LOCAL_MATERIAL_FOUND,
        // KEYPOINTS,
        // IMPACT_ASSESSMENT_OF_PLANT,
        // RECOMMENDED_LINE,
        // FEEL_FREE_TO_CONNECT,
        // GUN_MAINTENANCE_MANUAL,
        // GUN_MAINTENANCE_MANUAL_HEAD,
    } = LANGUAGES

    const copyToClipboard = () => {
        if (contentRef.current) {
            const contentHtml = contentRef.current.innerHTML;

            // Create a temporary element to copy the HTML as rich text
            const tempElement = document.createElement("div");
            tempElement.style.position = "absolute";
            tempElement.style.left = "-9999px";
            tempElement.innerHTML = contentHtml;

            document.body.appendChild(tempElement);

            const range = document.createRange();
            range.selectNodeContents(tempElement);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            try {
                document.execCommand("copy");
                alert("Content copied successfully!");
            } catch (err) {
                console.error("Failed to copy content:", err);
                alert("Failed to copy content.");
            }

            document.body.removeChild(tempElement);
        }
        emailModals.createServiceAPI(form, selectedSpare)
    };


    return (
        <div >
            <div className="email-to-copy">
                <Button variant="contained" onClick={copyToClipboard}>Copy Email</Button>
            </div>
            <div ref={contentRef}>
                <div className="body-email">
                    <div class="container">
                        {/* <!-- Header --> */}

                        {/* <!-- Content --> */}
                        <div class=" container">
                            <div class="header">
                                {/* <img src={vacspl_logo} alt="Company Logo" /> */}
                                Service Report & Recommendations
                                {/* <img src={gema_logo} alt="Parent Company Logo" /> */}
                            </div>
                            <div class=" content">
                                <div className="head-gema-email">
                                    <img src={gema_logo} alt="Parent Company Logo" />
                                </div>
                                <br />
                                <h3 className="customer">Customer: {(form.client || {}).client_name}</h3>
                                <br />
                                <p>Dear Sir,</p>
                                {/* <p>Dear {client_name || "Sir"},</p> */}
                                <br />
                                <p>I hope this email finds you in good health. Following our recent visit to your facility, we conducted a thorough inspection of your powder coating plant, gun, and machinery. Below are our findings and recommendations:</p>
                                <p></p>
                                {form.isMachineOkay && <Fragment>
                                    <h3>Findings:</h3>
                                    <ul>{LANGUAGES.NO_ISSUE_FOUND.map(item => <li>{item}</li>)}</ul>
                                </Fragment>}
                                {selectedSpare.isDamagedComponentAvailable &&
                                    <Fragment>
                                        <h3>Findings:</h3>
                                        {selectedSpare.isDamagedComponentAvailable.length ?
                                            <Fragment>
                                                <p>
                                                    During the servicing of the machines, we identified several damaged or malfunctioning spare parts that require immediate replacement. Specifically, the following component needs urgent attention:
                                                </p>
                                                <ul>
                                                    {selectedSpare.isDamagedComponentAvailable.map(item => <li>{item.label} - {item.quantity} {CONSTANTS.SPARE_UNIT_MAPPING[item.unit]}</li>)}
                                                </ul>
                                            </Fragment> :
                                            <Fragment>
                                                <p>During the service of the machines we have found some spares that are damaged or not working properly. These components needs to be replaced as soon as possible. We will send the list of the components with quotation at earliest so that you will not face any problem.</p>
                                            </Fragment>
                                        }
                                    </Fragment>
                                }
                                {selectedSpare.isRecommendedComponentAvailable &&
                                    <Fragment>
                                        <h3>Recommendations:</h3>
                                        {selectedSpare.isRecommendedComponentAvailable.length ?
                                            <Fragment>
                                                <p>

                                                    Recommended Spare parts for avoiding  <strong>future breakdown:
                                                    </strong>
                                                </p>
                                                <ul>
                                                    {selectedSpare.isRecommendedComponentAvailable.map(item => <li>{item.label} - {item.quantity} {CONSTANTS.SPARE_UNIT_MAPPING[item.unit]}</li>)}
                                                </ul>
                                            </Fragment> :
                                            <Fragment>
                                                <p>During the service of the machines we have found some spares that are damaged or not working properly. These components needs to be replaced as soon as possible. We will send the list of the components with quotation at earliest so that you will not face any problem.</p>
                                            </Fragment>
                                        }
                                    </Fragment>
                                }
                                <br />
                                <strong>
                                    <p>Please find the attached service report for detailed information.</p>
                                </strong>

                                <h3>Machinery Condition</h3>
                                {form.isMachineOkay &&
                                    <Fragment>
                                        <p>{OVERALL_PLANT_CONDITION.NO_ISSUE_FOUND.content[0]}</p>
                                    </Fragment>
                                }
                                {!form.isMachineOkay && <Fragment>

                                    {form.isPlantRunning ?
                                        <p>While it is commendable that the machine is currently operational, it is crucial to address the components in poor condition to ensure continued efficiency.</p> :
                                        <p>The Plant / Gun / Machine is in non-Operational and the listed components/spares are required to make the machine operational again.</p>
                                    }
                                </Fragment>}

                                {form.isUsingDuplicateSpares &&
                                    <Fragment>
                                        <h3>Local / Non-original Materials Found:</h3>
                                        <p>
                                            We also discovered some non-original materials that could lead to future issues, potentially causing plant, gun, or machine failure. It is advisable to replace these with original components to avoid such risks.
                                        </p>
                                    </Fragment>
                                }

                                {(form.isGenTerms || true) && <Fragment>

                                    <h3>Considerations for Maintaining a Healthy Plant, Gun, or Machine:</h3>
                                    <ul>
                                        <li><strong>Constant Voltage Transformer (CVT)</strong> and an <strong>Air Dryer</strong> are must to have with machine</li>
                                        <li>Damaged or malfunctioning components can lead to plant/gun/machine failure.</li>
                                        <li>Decreased efficiency will impact daily production.</li>
                                        <li>Increased powder consumption per component will raise costs.</li>
                                        <li>Non-original components can degrade machine performance.</li>
                                        <li>Production times may increase.</li>
                                    </ul>
                                </Fragment>}
                                <br />
                                <p class="highlight">
                                    NOTE: Please note that due to the presence of local or non-original materials identified during any inspection, we will not be able to provide further service, and any existing warranty will be terminated.
                                </p>
                                <p class="highlight">
                                    NOTE: Please be advised that the absence of a <strong>Constant Voltage Transformer (CVT)</strong> and an <strong>Air Dryer</strong> can significantly compromise the life and performance of the GEMA machine. It is mandatory to install/attach Constant Voltage Transformer (CVT) and Air Dryer with GEMA machine.
                                </p>


                                {form.isCostOnImpact &&
                                    <Fragment>
                                        <h3>Impact Assessment:</h3>
                                        <p>If you wish, we can provide a detailed report outlining the potential impact on costs, production, efficiency, and overall operational duration. This will help clarify the necessary improvements.</p>
                                    </Fragment>
                                }

                                <h3>Gun Maintenance and Cleaning Procedure:<br /></h3>
                                <p><a href="https://drive.google.com/file/d/150I27vYhzTG1Zal36NM37AopBBwvYEGS/view" rel="noreferrer" target="_blank">Maintenance Procedure (click here)</a></p>
                                <br />
                                <p>We strongly recommend addressing these issues (if any) promptly to maintain optimal plant/gun/machine performance and prevent future problems.
                                </p>
                                <br />
                                <p>Please feel free to contact us if you have any questions or need further assistance.</p>
                                <br /> <br />
                                <EmailSignature user={user} />
                            </div>
                        </div>
                        <EmailFooter />
                        

                        {/* <!-- Footer --> */}
                    </div>
                </div>

            </div>


        </div>
    );
};

export default TestClipboard;
